import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';
const AUTH_URL = `${API_URL}/authRoutes`;

// Get auth token from localStorage
const getAuthHeader = () => {
  const token = localStorage.getItem('token');
  return token ? { Authorization: `Bearer ${token}` } : {};
};

const permissionService = {
  // Get all permissions with pagination and search
  getAllPermissions: async ({ page = 1, limit = 5, search = '' } = {}) => {
    try {
      const response = await axios.get(`${AUTH_URL}/permissions`, {
        headers: getAuthHeader(),
        params: { page, limit, search }
      });
      return { success: true, data: response.data };
    } catch (error) {
      throw error.response?.data || { message: 'Failed to fetch permissions' };
    }
  },

  // Get permission by ID
  getPermissionById: async (permissionId) => {
    try {
      const response = await axios.get(`${AUTH_URL}/permissions/${permissionId}`, {
        headers: getAuthHeader()
      });
      return { success: true, data: response.data };
    } catch (error) {
      throw error.response?.data || { message: 'Failed to fetch permission' };
    }
  },

  // Create new permission
  createPermission: async (permissionData) => {
    try {
      const response = await axios.post(`${AUTH_URL}/permissions`, permissionData, {
        headers: getAuthHeader()
      });
      return { success: true, data: response.data };
    } catch (error) {
      throw error.response?.data || { message: 'Failed to create permission' };
    }
  },

  // Update permission
  updatePermission: async (permissionId, permissionData) => {
    try {
      const response = await axios.put(`${AUTH_URL}/permissions/${permissionId}`, permissionData, {
        headers: getAuthHeader()
      });
      return { success: true, data: response.data };
    } catch (error) {
      throw error.response?.data || { message: 'Failed to update permission' };
    }
  },

  // Delete permission
  deletePermission: async (permissionId) => {
    try {
      const response = await axios.delete(`${AUTH_URL}/permissions/${permissionId}`, {
        headers: getAuthHeader()
      });
      return { success: true, data: response.data };
    } catch (error) {
      throw error.response?.data || { message: 'Failed to delete permission' };
    }
  },

  // Check if user has a specific permission
  checkPermission: async (permissionName) => {
    try {
      const response = await axios.post(`${AUTH_URL}/permissions/check`,
        { permissionName },
        { headers: getAuthHeader() }
      );
      return { success: true, hasPermission: response.data.hasPermission };
    } catch (error) {
      throw error.response?.data || { message: 'Failed to check permission' };
    }
  }
};

export default permissionService;
